<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Create Vendor</h1>
            </div>
            <div class="col-sm-6">

                
            </div>
        </div>
    </div>
</section>


<section class="content"><div class="row"><div class="col-md-12"><div class="box box-info ">




    

    <div class="row">
        <div class="col-md-12">
    
    
    
          <form id="form_new_vendor">
            <table class="table table-hover table-bordered" style="width:100%">
                <tr>
                  <th class="bg-gray ">Vendor Number</th>
                  <td><input class="form-control" type="text" value="{{vdata[0].vendor_id}}" disabled></td>
                </tr>

                <tr>
                  <th class="bg-gray ">Created By</th>
                  <td><input class="form-control" type="text" value="Engin" disabled></td>
                </tr>                      

                <tr>
                  <th class="bg-gray ">Vendor Name</th>
                  <td><input class="form-control" type="text" name="vendor_name" value="{{vdata[0].vendor_name}}"></td>
                </tr>

                <tr>
                  <th class="bg-gray ">Note</th>
                  <td><textarea name="note" class="form-control" >{{vdata[0].note}}</textarea></td>
                </tr>  

                <tr>
                    <th class="bg-gray ">Address</th>
                    <td><textarea name="address" class="form-control" >{{vdata[0].address}}</textarea></td>
                </tr> 
                
           </table>  
           <div class="tar">
              <button class="btn btn-danger"  [routerLink]="['/app/vendor']" routerLinkActive="router-link-active" > Cancel </button> 
              <button class="btn btn-success" (click)="create('form_new_vendor');"> Create </button>
          </div>   

          <input class="form-control" type="hidden" name="vendor_id"   value="{{vdata[0].vendor_id}}" >

      </form>
    
    
            
        </div>
    </div>
    





</div></div></div></section>